import React from 'react';
interface FormFieldProps {
  id: string;
  label: string;
  required?: boolean;
  hint?: string;
  error?: string;
  children: React.ReactNode;
}
export function FormField({
  id,
  label,
  required,
  hint,
  error,
  children
}: FormFieldProps) {
  return <div className="flex flex-col space-y-1.5 mb-4" data-id="element-255">
      <label htmlFor={id} className="text-sm font-medium text-foreground flex items-center" data-id="element-256">
        
        {label}
        {required && <span className="text-destructive ml-1" aria-hidden="true" data-id="element-257">
            *
          </span>}
      </label>
      {hint && <p className="text-xs text-muted-foreground mb-1" data-id="element-258">{hint}</p>}
      <div className="relative" data-id="element-259">{children}</div>
      {error && <p className="text-sm text-destructive mt-1" id={`${id}-error`} role="alert" data-id="element-260">
        
          {error}
        </p>}
    </div>;
}